/**
 * Derive the friendly display alias from a canonical ref. The pill and
 * the suggestion menu both render this — never the raw
 * `@step.<id>.<output>` form — so authors see `@channelId` instead of
 * `@step.detect_intent.channelId`.
 *
 * - `@params.<name>` → `<name>`
 * - `@step.<id>.<output>` → `<output>`
 * - `@step.<id>.<id>:<output>` → `<output>` (drop the redundant step-id prefix
 *    that human-step field / decision ids carry — the ref already namespaces by
 *    step, so `@step.s.s:notes` reads as `@notes`, not `@s:notes`)
 * - `@step.<id>` (no output) → `<id>`
 * - `@run.<x>` / `@env.<x>` → `run.<x>` / `env.<x>` (scope kept; already short)
 */
export function deriveRunbookRefAlias(ref: string): string {
  const stripped = (ref || '').replace(/^@/, '')
  const paramsMatch = /^params\.(.+)$/.exec(stripped)
  if (paramsMatch) return paramsMatch[1]
  const stepWithOutput = /^step\.([^.]+)\.(.+)$/.exec(stripped)
  if (stepWithOutput) {
    const [, stepId, output] = stepWithOutput
    return output.startsWith(`${stepId}:`)
      ? output.slice(stepId.length + 1)
      : output
  }
  const stepOnly = /^step\.(.+)$/.exec(stripped)
  if (stepOnly) return stepOnly[1]
  return stripped
}
